import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const postHog = defineConnector({
  identifier: "postHog",
  name: "PostHog",
  tagLine: "Product analytics platform",
  logo,
  protocol: "http",
  tags: ["data", "engineering"],
  defaultUrlPattern: () => "https://app\\.posthog\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get a personal API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [PostHog](https://app.posthog.com/) and navigate to **Settings** > **Personal API Keys** to create a new key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "PostHog API key",
          required: true,
          placeholder: "phx_...",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
    {
      title: "Enter your PostHog host (optional)",
      items: [
        {
          kind: "markdown",
          content:
            "If you’re using PostHog Cloud US, leave this as `https://app.posthog.com`. For EU, use `https://eu.posthog.com`. For self-hosted, enter your instance URL.",
        },
        {
          kind: "input",
          label: "PostHog host",
          defaultValue: "https://app.posthog.com",
          target: { kind: "configuration", field: "host" },
          helperText: "Your PostHog instance URL.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.posthog.com/api/projects",
  },
  publicEnvVars: ({ host }) => ({
    POST_HOG_URL: host || "",
  }),
});
